export default function organizationcategories(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                organizationcategory: action.organizationcategory,
            }
        case 'ADD_CURRENT_ORGANIZATION':
          return {
              ...state,
              organizationcategory: action.organizationcategory,
              organization: action.organization,
          }
        default:
            return state;
    }
}
